import React, { useState } from "react";
import "./EditProfileMaritalStatus.css";

const EditProfileMaritalStatus = (props) => {
    const [marStatus, setMarStatus] = useState("");

    return (
        <div className="edit-profile-marital-status">
            <div className="first-name-h-eading">
                <div className="label-19 nunito-semi-bold-shuttle-gray-14px">Marital Status</div>
            </div>
            <div className="overlap-group3-8">
                <select className="group-1000005022 nunito-semi-bold-haiti-11-7px" onChange={(e) => {
                    const selectedMarStatus = e.target.value;
                    setMarStatus(selectedMarStatus);
                    props.getStatusData(selectedMarStatus);
                }}>
                    <option value=""></option>
                    <option value="married">Married</option>
                    <option value="common-law">Living Common Law</option>
                    <option value="widowed">Widowed</option>
                    <option value="divorced">Divorced</option>
                    <option value="seperated">Seperated</option>
                    <option value="single">Single</option>
                </select>
            </div>
        </div>
    )
}

export default EditProfileMaritalStatus;